module.exports = __webpack_public_path__ + "static/media/Me_2.a5084bca.jpeg";